import {createFileRoute, redirect} from '@tanstack/react-router'

import privateRoute from '@/auth/middleware/privateRoute'

export const Route = createFileRoute('/_account/order/')({
  beforeLoad: ({context, location}) => {
    privateRoute(context.store, location.href)

    throw redirect({to: '/orders', replace: true})
  },
})
